import React from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var SubStockName = function (props) {
    var device = DeviceContext();
    return (React.createElement("div", { className: device && device.isDesktop
            ? "DMSanN_14_400 txt_secondary-gray "
            : "DMSansNormal_12_400  txt_secondary-gray lh-140" }, props.stockName));
};
export default SubStockName;
